

import "../../assests/Login1.css"
import { Button } from "antd";
import { CopyrightOutlined } from "@ant-design/icons";
import Logo from "../../assests/tata-aia-3.webp"
import { Link } from "react-router-dom";


const ResetPasswordMessage = () => {

    return (
        <>
            <div className="login-wapper">

                <div className="login-form" style={{ marginTop: "70px", padding: "50px" }}>
                    <img alt="logo1" src={Logo} style={{ maxWidth: "300px" }} />
                      <p className="reset-text">Password reset successfully.</p>
                      <Button type="primary" onClick={() => window.location.href = "/"} style={{ width: "100%", height: "42px", marginBottom: "20px" }}>   Login Now</Button>
                </div>

               <div className="login-footer1">
                            <div style={{marginLeft:"15px"}}>Copyright <CopyrightOutlined /> {new Date().getFullYear()} TATA </div>
                            {/* <div>  <Link className="lms-link">Security Tips <InfoCircleOutlined /></Link></div> */}
                            <div style={{marginRight:"15px"}}>  <Link to="#" className="lms-link">Terms & Policies</Link></div>
                        </div>
            </div>
        </>
    )
}

export default ResetPasswordMessage;
